<div fxLayout="row" fxLayoutAlign="start center" fxFlex="100" fxLayoutGap="10px">
  <vdw-tag [value]="'ORDERBOOK.ORDER_LINE_STATUS.' + statusLabel | bmsTranslate | uppercase" [color]="getColor()"></vdw-tag>

  @if (missingDesign) {
    <mat-icon class="icon-16 flex-no-shrink" svgIcon="error" [matTooltip]="'ORDERBOOK.MISSING_DESIGN' | bmsTranslate"></mat-icon>
  } @else if (!canBePlanned) {
    <mat-icon class="icon-16 flex-no-shrink" svgIcon="warning" [matTooltip]="'ORDERBOOK.CAN_NOT_BE_PLANNED' | bmsTranslate" matTooltipPosition="right"></mat-icon>
  }
</div>
